import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { ModalDirective } from '../../directives/modal.directive';
import { RequestsComponent } from '@clooper/common';

@Component({
  selector: 'app-modal',
  template: ``,
  exportAs: 'modal'
})
export class ModalComponent extends RequestsComponent implements AfterViewInit {

  @ViewChild('modal', { static: false }) modal: ModalDirective;

  ngAfterViewInit() {
    this.modal.show();
    this.onModalShown();
  }

  onModalShown() {}

}
